import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CelumButtonModule } from '@celum/common-components/button';
import { CelumIcon } from '@celum/common-components/icon';

import { EmptyPage } from './components/empty-page';

@NgModule({
  imports: [CommonModule, CelumIcon, CelumButtonModule, EmptyPage, TranslatePipe],
  declarations: [],
  exports: [EmptyPage, CelumButtonModule, TranslatePipe]
})
export class CelumEmptyPageModule {}
